<template>
  <div class="pdf-elements-page" data-testid="pdf-elements-page">
    <div class="page-header">
      <h3 class="page-title">{{ t('Elementos dos documentos PDF') }}</h3>
      <Button
        :label="t('Novo elemento')"
        icon="pi pi-plus"
        data-testid="pdf-elements-new-button"
        @click="handleNewElement"
      />
    </div>

    <PDFElementsTable
      ref="tableRef"
      @edit="handleEditElement">
    </PDFElementsTable>

    <!-- PDFElementsModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import PDFElementsTable from './PDFElementsTable.vue';
// PDFElementsModal is centralized in ModalManager.vue

const { t } = useI18n();

interface PDFElementsTableInstance {
  loadData: () => void;
}

const tableRef = ref<PDFElementsTableInstance | null>(null);

const handleNewElement = (): void => {
  log('PDFElementsPage', 'handleNewElement', 'Emitting modal open event for new element');
  eventBus.emit('modal.pdf-elements.open', { id: null });
};

const handleEditElement = (elementName: string): void => {
  log('PDFElementsPage', 'handleEditElement', 'Emitting modal open event for edit', elementName);
  eventBus.emit('modal.pdf-elements.open', { id: elementName });
};

onMounted(() => {
  log('PDFElementsPage', 'mounted', 'Component mounted');
});
</script>

<style scoped>
.pdf-elements-page {
  padding: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.page-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}
</style>
